import { map } from "rxjs/operators";
import { inject, injectable } from "tsyringe";
import { DocumentDetail } from "src/containers/documents-download/models/document-detail.model";
import { DocumentsDownloadService } from "src/containers/documents-download/services/document-download/documents-download.service";
import { EpsContractor } from "src/containers/eps/domain/models/contractor";
import { Insured } from "src/shared/models";
import { Document } from "src/containers/documents-download/models/document.model";
import { EpsService } from "src/containers/eps/service/eps-service";
import { EpsPlan } from "src/shared/models";
import { autoBind } from "src/shared/decorators/autobind";
import type {
    GetEpsContractorParams,
    GetEpsHolderParams,
} from "src/containers/eps/core/types";

@injectable()
export class EpsDetailViewModel {
    constructor(
        @inject("EpsService") private service: EpsService,
        @inject("DocumentsDownloadService")
        private docsService: DocumentsDownloadService
    ) {
        this.getContractor = this.getContractor.bind(this);
        this.getHolder = this.getHolder.bind(this);
    }

    @autoBind
    getContractor(params: GetEpsContractorParams): Promise<EpsContractor> {
        return this.service.getContractor(params).toPromise();
    }

    @autoBind
    getHolder(params: GetEpsHolderParams): Promise<Insured> {
        return this.service
            .getInsureds(params)
            .pipe(map((insureds) => insureds[0]))
            .toPromise();
    }

    @autoBind
    getDocument(plan: EpsPlan): Promise<Document | undefined> {
        return this.docsService
            .getEpsDocumentList(plan)
            .then((docs) => docs.find((doc) => doc.documentType === "Plan"));
    }

    @autoBind
    getDocumentDetail(plan: EpsPlan): Promise<DocumentDetail | undefined> {
        return this.docsService.getEpsDocumentDetail(plan);
    }

    @autoBind
    getCertificate(plan: EpsPlan): Promise<DocumentDetail | undefined> {
        return this.docsService.getEpsCertificateDocumentDetail(plan);
    }
}
